const handleInputChange = (stateData, target) => {
    const { name, value, type, checked } = target;
    // console.log(name, value, type, checked)
    let data
    if (type === "checkbox") {
        data = { ...stateData, [name]: checked };
      } else if (type === "select-multiple") {
        let arrayToUpdate = stateData[name];
        if (arrayToUpdate.includes(value)) {
          let spliceIndex = arrayToUpdate.indexOf(value);
          arrayToUpdate.splice(spliceIndex, 1);
          data = { ...stateData, [name]: arrayToUpdate };
        } else {
          data = { ...stateData, [name]: stateData[name].concat(value) };
        }
      } else {
        data = { ...stateData, [name]: value };
      }
      return data
}

export default handleInputChange